import { render, staticRenderFns } from "./Chapter8_2.vue?vue&type=template&id=013ccf84&scoped=true&"
import script from "./Chapter8_2.vue?vue&type=script&lang=js&"
export * from "./Chapter8_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013ccf84",
  null
  
)

export default component.exports